import { DatePipe } from "@angular/common";
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as _ from "lodash";
import * as fromRootStore from "../../../reducers";
import { CommonService } from "../../../services/common.service";
import { Combo2Service, ComboService, ExcelService, ReportService } from "../../../services/index";
import { PurchaseOrderService } from "../../../services/purchaseorder.service";
declare var google;

@Component({
  selector: "agentCommissionReport",
  host: { "(window:keydown)": "hotkeys($event)" },
  templateUrl: "./agentCommissionReport.html",
})
export class agentCommissionReport implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input("params") params: any;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();

  gridOptions: any;
  designnoList = [];
  dataList = [];
  qualityList: any;
  // colorList: any;
  codeList: any;
  widthList: any[];
  brandList: any[];
  isLoadMask: Promise<any>;
  selectedDlrMapList: any[];
  loadingIndicator: boolean = true;
  reorderable: boolean = true;
  backbutExists: boolean = false;
  finyearList = [];
  exceldata: any;
  colorList = [
    "lightcyan",
    "bisque",
    "gb(229 225 223)",
    "#f9e2e2",
    "#efe7ef",
    "rgb(243 228 247)",
    "rgb(249 245 235)",
    "lightgoldenrodyellow",
    "rgb(240 249 249)",
    "#ddf7dd"
  ];
  filter: any = {
    from_date: new Date(),
    to_date: new Date(),
    start_date: new Date(),
    end_date: new Date(),
    dateAgent: "",
    rec_date: "",
    pri_id: "",

    agent_id: "",
    pay_id: "",
    groupby: "team_Wise",
    param: "",
    trans_rep: ""
  };
  printConfig: any = {
    title: "Agent Commission Report",
    columns: [],
    rows: [],
  };

  partyList = [];
  @ViewChild("filterPanel") filterPanel;

  finyearCtrl: FormControl = new FormControl();
  columns = [];
  partycodeList = [];
  toggleCol = [];
  menu: any;
  filterExpand = false;
  filterData: any;
  user: any;
  agentVisible: boolean = false;
  companyInfo: any = [];
  orderList: any = [];
  constructor(
    public store: Store<fromRootStore.State>,
    private commonserv: CommonService,
    private poservice: PurchaseOrderService,
    private excelService: ExcelService,
    public datePipe: DatePipe,
    private combo2Service: Combo2Service,
    private reportService: ReportService,
    public toasterService: ToasterService,
    public comboservice: ComboService
  ) {
  }

  ngOnInit(): void {
    this.filter.param = this.menu.param;
    this.filter.trans_rep = this.menu.trans_rep;
    this.finyearCombo();
    this.getColumns();

    this.toggleCol = Object.assign({}, this.columns);
  }

  hotkeys(event) {
    if (this.active) {
    }
  }

  getColumns() {
    this.columns = [];

    this.gridOptions = {
      columns: this.columns,
      loading: true,
      data: [],
    };
    this.toggleCol = Object.assign({}, this.columns);

    this.getcommissionReport();
  }

  onOpenedFilter(): void {
    setTimeout(function () {
      $("#party_code").focus();
    }, 100);
  }
  exportToExcel($event) {
    this.excelService.exportAsExcelFile(this.exceldata, this.title);
  }



  onCellClick(event) {
    let row = event.row;
    if (this.filter.groupby == "team_Wise") {
      this.filter.groupby = "salesPerson";

    }
    else if (this.filter.groupby == "salesPerson") {
      this.filter.groupby = "monthWise";
      this.filter.agent_id = row.agent_id;

    }
    else if (this.filter.groupby == "monthWise") {
      this.filter.groupby = "voucherWise";
      this.filter.month_date = row.mo_date;
      // this.filter.rec_date = row.ref_date;
      this.filter.start_date = "";
      this.filter.end_date = "";


    }

    // else if (this.filter.groupby == "dateWise") {
    //   this.filter.groupby = "voucherWise";
    //   this.filter.entry_date = row.entry_date;
    // }
     else if (this.filter.groupby == "voucherWise") {
      this.filter.groupby = "entryWise";
    }

    if (this.filter.groupby != "entryWise") {
      this.getcommissionReport();
    }
    else {
      this.filter.groupby = "voucherWise";
      this.getPaymentVoucherDetails('Commission_View', row);
    }

  }
  onbackbutton() {
    if (this.filter.groupby == "salesPerson") {
      this.filter.groupby = "team_Wise";

    } else if (this.filter.groupby == "monthWise") {
      this.filter.groupby = "salesPerson";
      this.filter.agent_id = "";

    }
    // else if (this.filter.groupby == "dateWise") {
    //   this.filter.groupby = "monthWise";
    //   this.filter.mo_date = '';


    // }
    else if (this.filter.groupby == "voucherWise") {
      this.filter.groupby = "monthWise";
      this.filter.mo_date = '';
    }
    this.getcommissionReport();
  }

  applyFilter(): void {
    this.getcommissionReport();
  }


  finyearCombo() {
    let that = this;
    this.combo2Service.finyearCombo().then((res: any) => {
      that.finyearList = res.data;
      var temp = ["Core", "All"];
      that.finyearList.concat(temp);
      that.filter.finyear = res.data[0].finyear;
      that.finyearCtrl.setValue(res.data[0].fin_id);
      that.filter.from_date = res.data[0].start_date;
      that.filter.to_date = res.data[0].end_date;

    });
  }

  displayFinyear(comboType: string, id: number) {
    if (id) {
      let temp_data = this.finyearList.filter(e => e.fin_id == id)
      this.filter.from_date = temp_data[0].start_date;
      this.filter.to_date = temp_data[0].end_date;
    }
    let list: any = [];

    if (comboType == "Finyear") {
      list = this.finyearList;
    }

    if (id && list.length > 0) {
      let fitem = _.find(list, { fin_id: id });
      return fitem["finyear"];
    }
    return "";
  }
  getcommissionReport(): void {
    this.filter.from_date = this.datePipe.transform(
      this.filter.from_date,
      "yyyy-MM-dd"
    );
    this.filter.to_date = this.datePipe.transform(
      this.filter.to_date,
      "yyyy-MM-dd"
    );
    let params = {
      filter: JSON.stringify(this.filter),
    };
    let that = this;
    that.gridOptions = {
      loading: true,
      columns: [],
    };
    this.isLoadMask = this.reportService
      .getAgentCommissionReport(params)
      .then(function (res: any) {
        that.loadingIndicator = false;
        that.orderList = res.data;
        let temp = 0;
        res.data.forEach((el, ind) => {
          el.check_row = false;
          if (ind >= 10) {
            temp = temp + 1;
            if (temp == 10) {
              temp = 0;
            }
            el.background = that.colorList[temp];
          }
          else {
            el.background = that.colorList[ind];
          }

        });
        that.backbutton();
        that.gridOptions = {
          cols: res.cols,
          columns: res.columns,
          data: res.data,
          loading: false,
        };
        that.exceldata = that.getData(res.columns, res.data);
      });
  }

  getData(columns, data) {
    let cols = columns;
    let value = data;
    let rows = [],
      row,
      ind,
      type,
      val,
      rlen = data.length,
      clen = columns.length;

    for (let i = 0; i < data.length; i++) {
      let sno = i + 1;
      row = Object.assign({}, data[i]);
      let newrow = {
        Sno: sno,
      };
      for (let j = 1; j < clen; j++) {
        let type = cols[j].type,
          index = cols[j].index,
          prop = cols[j].prop,
          name = cols[j].name;

        newrow[name] = row[prop];
      }

      rows.push(newrow);
      sno++;
    }
    return rows;
  }

  getRowClass(event) {
    return event.rowtype == "summary" ? "summary-row" : "";
  }

  refreshData() {
    let columns = this.columns,
      data = this.dataList,
      row = this.getSummaryRow(data, columns);
    data.push(row);
    // this.page.count = data.length;
    // this.dataList = data;
  }

  getSummaryRow(data, columns) {
    let row = {
      type: "summary",
    };
    for (let i = 0; i < columns.length; i++) {
      let col = columns[i];
      switch (col.summary) {
        case "sum":
          let total = 0;
          for (let j = 0; j < data.length; j++) {
            let dat = data[j];
            total += dat[col.prop];
          }
          row[col.prop] = Math.round(total * 100) / 100;
          break;
        default:
          row[col.prop] = "";
          break;
      }
    }
    return row;
  }

  getPaymentVoucherDetails(mode: string, row: any): void {
    let listUpdateEvent = new EventEmitter();
    listUpdateEvent.subscribe(() => {
      //   this.getOrderList();
    });
    row.tabevent = listUpdateEvent;
    let tabObj = {};


    tabObj = {
      action: "NewTab",
      params: {
        //   tabParent: 'Transaction',
        tabName: "VIEW PAYMENT VOUCHER",
        title: "VIEW PAYMENT VOUCHER",
        tabParent: "SALES_PLAN",
        mode: mode,
        data: row,
        name: "VIEW PAYMENT VOUCHER",
      },
    };

    if (row.deduction_type == 'PAYMENT TO AGENT') {
      tabObj = {
        action: "NewTab",
        params: {
          //  tabParent: 'Transaction',
          tabName: "VIEW SALESPERSON PAYMENT",
          title: "VIEW SALESPERSON PAYMENT",
          tabParent: "SALES_PLAN",
          mode: mode,
          data: row,
          name: "addEditAgentpayment",
        },
      };
    }


    this.tabUpdateEvent.emit(tabObj);
  }

  backbutton() {
    if ($(".data-history-btn").length) {
      this.backbutExists = false;
    } else {
      this.backbutExists = true;
    }
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/salesReports/agentCommissionReport/agentCommissionReport.ts